import { useState, type FormEvent } from 'react'

import { post } from '@/lib/api'
import { setToken } from '@/lib/auth'
import styles from './LoginPage.module.css'

interface LoginResponse {
  token: string
}

export default function LoginPage() {
  const [password, setPassword] = useState('')
  const [otp, setOtp] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const canSubmit =
    password.trim().length > 0 && otp.trim().length === 6 && !loading

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    if (!canSubmit) return
    setLoading(true)
    setError(null)
    try {
      const res = await post<LoginResponse>('/auth/login', {
        password: password.trim(),
        otp: otp.trim(),
      })
      setToken(res.token)
      window.location.href = '/'
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : '로그인에 실패했습니다. 다시 시도해주세요.',
      )
      setLoading(false)
    }
  }

  return (
    <div className={styles.loginWrap}>
      <form className={styles.loginCard} onSubmit={handleSubmit}>
        <div className={styles.loginLogo}>
          <span className={styles.loginLogoMark}>✦</span>
          <span>Career Studio</span>
        </div>
        <p className={styles.loginSubtitle}>관리자 로그인</p>

        <div className={styles.formGroup}>
          <label className={styles.formLabel} htmlFor="login-password">
            비밀번호
          </label>
          <input
            id="login-password"
            className={styles.formInput}
            type="password"
            autoComplete="current-password"
            placeholder="비밀번호를 입력하세요"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={loading}
            autoFocus
          />
        </div>

        <div className={styles.formGroup}>
          <label className={styles.formLabel} htmlFor="login-otp">
            OTP 인증코드
          </label>
          <input
            id="login-otp"
            className={`${styles.formInput} ${styles.otpInput}`}
            type="text"
            inputMode="numeric"
            autoComplete="one-time-code"
            maxLength={6}
            placeholder="000000"
            value={otp}
            onChange={(e) =>
              setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))
            }
            disabled={loading}
          />
        </div>

        <button
          type="submit"
          className={styles.loginBtn}
          disabled={!canSubmit}
        >
          {loading && <span className={styles.spinner} />}
          {loading ? '로그인 중…' : '로그인'}
        </button>

        {error && <div className={styles.errorMsg}>{error}</div>}

        <p className={styles.hint}>
          비밀번호와 인증 앱의 6자리 코드를 입력하세요.
        </p>
      </form>
    </div>
  )
}
